var map = {
	"./AppMaintenance.vue": [
		"f09b",
		"chunk-2d22ba49"
	],
	"./Business/business-client.vue": [
		"46a6",
		"chunk-0fba13f4"
	],
	"./Business/business-log.vue": [
		"8ac2",
		"chunk-2c506da6"
	],
	"./Business/businessList.vue": [
		"ca5c",
		"chunk-5f090e7d"
	],
	"./Business/detail/businessClient_detail.vue": [
		"83bd",
		"chunk-2d0de173"
	],
	"./Business/detail/businessDetail.vue": [
		"bfcc",
		"chunk-ca150548"
	],
	"./Business/index.vue": [
		"3b0e",
		"chunk-2d0c45fa"
	],
	"./Business/monitor/index.vue": [
		"b874",
		"chunk-0f4908c7"
	],
	"./CampaignCrypto.vue": [
		"97c6",
		"chunk-216b23f9",
		"chunk-b05fc674"
	],
	"./CampaignDistance.vue": [
		"0b25",
		"chunk-8130f122"
	],
	"./CampaignReward.vue": [
		"a1c3",
		"chunk-48a49359"
	],
	"./CommissionTopbar.vue": [
		"0958",
		"chunk-2d0a4f62"
	],
	"./CustomerManage.vue": [
		"36ba",
		"chunk-2ca8f586"
	],
	"./DineInSetting/DistrictSetting.vue": [
		"312b",
		"chunk-390136ce",
		"chunk-0dc630a0"
	],
	"./DineInStore/CreateStore/index.vue": [
		"e610",
		"chunk-390136ce",
		"chunk-03f733f9"
	],
	"./DineInStore/DineInStoreCategoryManagement.vue": [
		"4f6c",
		"chunk-390136ce",
		"chunk-7fc6e167"
	],
	"./DineInStore/ProductManagement/DineinProductMangement.vue": [
		"7ef1",
		"chunk-390136ce",
		"chunk-29460b4d"
	],
	"./DineInStore/SpecialClose/DineInSpecialClose.vue": [
		"b172",
		"chunk-3c07f80d"
	],
	"./DineInStore/StoreManagement/DineInStoreManagement.vue": [
		"31a1",
		"chunk-390136ce",
		"chunk-60fe507e"
	],
	"./DineInStore/StoreReview/DineInReviewBenefit.vue": [
		"45d5",
		"chunk-2d0c1788"
	],
	"./DineInStore/StoreReview/DineInReviewBenefitLog.vue": [
		"a9d3",
		"chunk-2d209b3d"
	],
	"./DineInStore/StoreReview/DineInStoreReviewManagement.vue": [
		"6249",
		"chunk-2d0cef37"
	],
	"./DineInStore/StoreType/CreateStoreType.vue": [
		"1083",
		"chunk-390136ce",
		"chunk-fc82cf34"
	],
	"./DineInStore/StoreType/DineInStoreTypeManagement.vue": [
		"1bd6",
		"chunk-390136ce",
		"chunk-f85059f8"
	],
	"./DineInStore/index.vue": [
		"df93",
		"chunk-2d229c12"
	],
	"./FindUserOTP.vue": [
		"9223",
		"chunk-31d34418"
	],
	"./Food/AddonList/index.vue": [
		"a55e",
		"chunk-63293c7e"
	],
	"./Food/BaseDistance/index.vue": [
		"1344",
		"chunk-4778bebd"
	],
	"./Food/CustomerBaseDistance/index.vue": [
		"b036",
		"chunk-7d7d4c64"
	],
	"./Food/FreeSetting/SetPriceRound/index.vue": [
		"bdaf",
		"chunk-7dcd2d12"
	],
	"./Food/PackageList/index.vue": [
		"c815",
		"chunk-0384761a"
	],
	"./Food/Promotion/PromotionLog.vue": [
		"6b01",
		"chunk-2d0da2e3"
	],
	"./Food/Promotion/index.vue": [
		"f760",
		"chunk-c504e584"
	],
	"./Food/RiderBaseDistance/index.vue": [
		"cd22",
		"chunk-1668d05e"
	],
	"./Food/SmallOrderDifference/_id.vue": [
		"3473",
		"chunk-6c2dfb6a"
	],
	"./Food/SmallOrderDifference/index.vue": [
		"3fd2",
		"chunk-473f030c"
	],
	"./Food/Transfer/TransferExtraStore/index.vue": [
		"5558",
		"chunk-2d0c8639"
	],
	"./Food/Transfer/TransferExtraTime/index.vue": [
		"4d12",
		"chunk-3067482f"
	],
	"./Food/Transfer/TransferList/index.vue": [
		"d4ea",
		"chunk-28b2cc79"
	],
	"./Food/Transfer/TransferSubDistrict/index.vue": [
		"dc03",
		"chunk-2d228fb8"
	],
	"./Food/Transfer/TransferZone/index.vue": [
		"b46a",
		"chunk-1d1cb056"
	],
	"./HomePage.vue": [
		"4842",
		"chunk-62470632"
	],
	"./HotelServices/HotelList/index.vue": [
		"dd2e",
		"chunk-5dde2f78"
	],
	"./HotelServices/index.vue": [
		"dacd",
		"chunk-2d228e94"
	],
	"./ManagerUserManage/Commission Area.vue": [
		"f457",
		"chunk-609a28a8"
	],
	"./ManagerUserManage/CommissionArea/CommissionDetail.vue": [
		"4511",
		"chunk-bb28f63e"
	],
	"./ManagerUserManage/ManagerInvoice/_id.vue": [
		"7682",
		"chunk-85167024"
	],
	"./ManagerUserManage/ManagerInvoice/create/index.vue": [
		"d6f6",
		"chunk-128f40b7"
	],
	"./ManagerUserManage/ManagerInvoice/edit/_id.vue": [
		"c5a4",
		"chunk-74b8e9ec"
	],
	"./ManagerUserManage/ManagerInvoice/index.vue": [
		"69f8",
		"chunk-b613e91c"
	],
	"./ManagerUserManage/Transaction.vue": [
		"75a0",
		"chunk-134871df"
	],
	"./ManagerUserManage/Transactionbill.vue": [
		"fb25",
		"chunk-312edd9e"
	],
	"./ManagerUserManage/bankApprove.vue": [
		"c707",
		"chunk-6249de8c"
	],
	"./ManagerUserManage/banklist.vue": [
		"1467",
		"chunk-d0e61022"
	],
	"./ManagerUserManage/commissionWithdraw.vue": [
		"bcc4",
		"chunk-5ff3c3fc",
		"chunk-533d02fe"
	],
	"./ManagerUserManage/index.vue": [
		"1d01",
		"chunk-5ff3c3fc",
		"chunk-2d0b648a"
	],
	"./ManagerUserManage/moneymanage.vue": [
		"af5a",
		"chunk-69a72ba7"
	],
	"./ManagerUserManage/transactionWithdrawView.vue": [
		"fec3",
		"chunk-4630b6cc"
	],
	"./Merchant/ActionsEventLog.vue": [
		"0fac",
		"chunk-11410ace"
	],
	"./Merchant/ContactApprove/index.vue": [
		"4240",
		"chunk-4a342e05"
	],
	"./Merchant/DocumentApprove/index.vue": [
		"aeca",
		"chunk-0f0c737a",
		"chunk-04d796f4"
	],
	"./Merchant/MerchantBanners.vue": [
		"900d",
		"chunk-390136ce",
		"chunk-2d212b99",
		"chunk-0180c40c"
	],
	"./Merchant/MerchantBanners/MerchantBannerForm.vue": [
		"e193",
		"chunk-390136ce",
		"chunk-6236f2c6"
	],
	"./Merchant/MerchantNews.vue": [
		"ab8b",
		"chunk-2d213001"
	],
	"./Merchant/StoreApprove/index.vue": [
		"6374",
		"chunk-3a33d4c0"
	],
	"./Merchant/StoreManageUser/StoreUserManagement.vue": [
		"a476",
		"chunk-d9e000ba"
	],
	"./Merchant/StoreRegistration/index.vue": [
		"6f33",
		"chunk-0f0c737a",
		"chunk-165ae914"
	],
	"./Merchant/UserList.vue": [
		"23db",
		"chunk-2d0b2775"
	],
	"./Merchant/UserLogApproval/index.vue": [
		"e519",
		"chunk-9e22996c"
	],
	"./Messenger/AddOn/index.vue": [
		"cff7",
		"chunk-4bb08975"
	],
	"./Messenger/AddOnTime/index.vue": [
		"0f72",
		"chunk-7473f1f8"
	],
	"./Messenger/ExtraTime/index.vue": [
		"3440",
		"chunk-02af7f44"
	],
	"./Messenger/VehicleType/index.vue": [
		"9dff",
		"chunk-e1735d78"
	],
	"./OrderDashboard/Cancel.vue": [
		"2fcb",
		"chunk-0e4ea87c",
		"chunk-05d11236"
	],
	"./OrderDashboard/Completed.vue": [
		"ce4f",
		"chunk-0e4ea87c",
		"chunk-ba1d30f8"
	],
	"./OrderDashboard/Cooking.vue": [
		"984b",
		"chunk-0e4ea87c",
		"chunk-122ef26b"
	],
	"./OrderDashboard/InQueue.vue": [
		"6d90",
		"chunk-0e4ea87c",
		"chunk-02cfa21a"
	],
	"./OrderDashboard/OnTheWay.vue": [
		"c5bd",
		"chunk-0e4ea87c",
		"chunk-15837a24"
	],
	"./OrderDashboard/OrderMade.vue": [
		"4812",
		"chunk-0e4ea87c",
		"chunk-140dc9d3"
	],
	"./OrderDashboard/OrderReceipt.vue": [
		"a59e",
		"chunk-93009f42"
	],
	"./OrderDashboard/Preorder.vue": [
		"bdac",
		"chunk-0e4ea87c",
		"chunk-3d2b6834"
	],
	"./OrderDashboard/ReadyToPick.vue": [
		"c7b3",
		"chunk-0e4ea87c",
		"chunk-603e6633"
	],
	"./OrderDineIn/Cancel.vue": [
		"2e33",
		"chunk-5cd7f6f0"
	],
	"./OrderDineIn/Complete.vue": [
		"37cf",
		"chunk-52eb4358"
	],
	"./OrderDineIn/NewOrder.vue": [
		"2dcc",
		"chunk-199674e9"
	],
	"./OrderDineIn/OnProcess.vue": [
		"fa75",
		"chunk-541dd802"
	],
	"./OrderDineIn/OrderDetail.vue": [
		"f7e6",
		"chunk-30e815d0"
	],
	"./OrderWesmart.vue": [
		"0315",
		"chunk-792df906"
	],
	"./OrderWesmart/Cancelled.vue": [
		"162d",
		"chunk-cfca9a8c"
	],
	"./OrderWesmart/Completed.vue": [
		"622c",
		"chunk-cfc62ce0"
	],
	"./OrderWesmart/OnProcess.vue": [
		"3afb",
		"chunk-cfc779a6"
	],
	"./OrderWesmart/OrderDetail.vue": [
		"8f9e",
		"chunk-d78c8450"
	],
	"./OrderWesmart/OrderMade.vue": [
		"b078",
		"chunk-cf9e3a5c"
	],
	"./OrderWesmart/PendingOrder.vue": [
		"aaf8",
		"chunk-2d2131a8"
	],
	"./POS/EditStoreApprove.vue": [
		"7715",
		"chunk-6ccf8ca7"
	],
	"./POS/InStoreOptionList.vue": [
		"85e9",
		"chunk-68c7a646"
	],
	"./POS/InStoreProductList.vue": [
		"d148",
		"chunk-390136ce",
		"chunk-2d212b99",
		"chunk-f5d52824",
		"chunk-2752f4fb"
	],
	"./POS/InStoreProductType.vue": [
		"23cf",
		"chunk-2d212b99",
		"chunk-f34c115a"
	],
	"./POS/OptionManagementList.vue": [
		"1245",
		"chunk-2d0aa958"
	],
	"./POS/OrderStoreReview.vue": [
		"0dc4",
		"chunk-2d0af65b"
	],
	"./POS/ProductApprove.vue": [
		"df3a",
		"chunk-3c74c3f9"
	],
	"./POS/ProductForm.vue": [
		"392f",
		"chunk-390136ce",
		"chunk-f86e15f2"
	],
	"./POS/ProductManage.vue": [
		"75b7",
		"chunk-32a40654"
	],
	"./POS/StoreInfo.vue": [
		"1b4f",
		"chunk-390136ce",
		"chunk-616ee5a6"
	],
	"./POS/StoreManage.vue": [
		"f04a",
		"chunk-390136ce",
		"chunk-51f043f4"
	],
	"./POS/StoreService.vue": [
		"1afd",
		"chunk-2d0b6004"
	],
	"./POS/StoreType.vue": [
		"ea70",
		"chunk-2d212b99",
		"chunk-488232d4"
	],
	"./POS/StoreUser.vue": [
		"8af9",
		"chunk-2d0e8e72"
	],
	"./PointManage/index.vue": [
		"2e8e",
		"chunk-7e2f9f7a"
	],
	"./Promotion/PromotionList.vue": [
		"b144",
		"chunk-45316cf0"
	],
	"./Promotion/PromotionLog.vue": [
		"5d35",
		"chunk-2d0d3667"
	],
	"./Report/Dashboard/CustomerReport.vue": [
		"8a95",
		"chunk-da015c6a"
	],
	"./Report/Dashboard/DetailCustomerReport.vue": [
		"ee12",
		"chunk-1738a99a"
	],
	"./Report/Dashboard/ExtraCreditZoneReport.vue": [
		"142f",
		"chunk-7a1454ee"
	],
	"./Report/Dashboard/FoodReceipt.vue": [
		"ec67",
		"chunk-23ae43b5"
	],
	"./Report/Dashboard/FreeReceipt.vue": [
		"af8c",
		"chunk-d8f82118"
	],
	"./Report/Dashboard/MainDashboard.vue": [
		"f780",
		"chunk-0c4d09c0"
	],
	"./Report/Dashboard/MessengerReceipt.vue": [
		"605f",
		"chunk-597f43a2"
	],
	"./Report/Dashboard/OrderDetailFood.vue": [
		"2b72",
		"chunk-0e4ea87c",
		"chunk-170ad624"
	],
	"./Report/Dashboard/OrderDetailMessenger.vue": [
		"9976",
		"chunk-0e4ea87c",
		"chunk-eff08f1a"
	],
	"./Report/Dashboard/OrderReport.vue": [
		"8949",
		"chunk-9aab4b4e"
	],
	"./Report/Dashboard/PromotionReport.vue": [
		"dc25",
		"chunk-34a9e3f4"
	],
	"./Report/Dashboard/RiderReport.vue": [
		"25f6",
		"chunk-01e1b2c8"
	],
	"./Report/Dashboard/SaleMessengerReport.vue": [
		"1f37",
		"chunk-6f7bf332"
	],
	"./Report/Dashboard/StorePayment.vue": [
		"9152",
		"chunk-3e66183a"
	],
	"./Report/Dashboard/StorePaymentOrder.vue": [
		"b30b",
		"chunk-0b5f8415"
	],
	"./Report/Dashboard/StoreReport.vue": [
		"5f3a",
		"chunk-4509e933"
	],
	"./Report/Dashboard/hotel-service/HotelOrderReport.vue": [
		"eebf",
		"chunk-4696f698"
	],
	"./Report/MainDashboard.vue": [
		"526b",
		"chunk-2d0c7b3f"
	],
	"./Report/MainDashboard/ConnectWalletReport.vue": [
		"4d01",
		"chunk-619a9f70"
	],
	"./Report/MainDashboard/DineInReport.vue": [
		"d380",
		"chunk-216b23f9",
		"chunk-7cd9ae62"
	],
	"./Report/MainDashboard/DineInReportByID.vue": [
		"98eb",
		"chunk-9b5eaae6"
	],
	"./Report/MainDashboard/DineInsaleReport.vue": [
		"5dec",
		"chunk-c634668a"
	],
	"./Report/MainDashboard/PackagesReport.vue": [
		"5556",
		"chunk-325f2874"
	],
	"./Report/MainDashboard/RewardReport.vue": [
		"5576",
		"chunk-16f7138d"
	],
	"./Report/MainDashboard/WellnessReport.vue": [
		"e40e",
		"chunk-4afa0012"
	],
	"./Report/MainDashboard/index.vue": [
		"195f",
		"chunk-2d7966b6"
	],
	"./Rider/Advertise.vue": [
		"2916",
		"chunk-50c92cd6"
	],
	"./Rider/Bank.vue": [
		"ef42",
		"chunk-5117e684"
	],
	"./Rider/DepositCommission.vue": [
		"5335",
		"chunk-0ac9f29f"
	],
	"./Rider/General.vue": [
		"d394",
		"chunk-2d21dca0"
	],
	"./Rider/Head.vue": [
		"449c",
		"chunk-41414a36"
	],
	"./Rider/Hub.vue": [
		"afa4",
		"chunk-b6946ba8"
	],
	"./Rider/Penalty.vue": [
		"dc1a",
		"chunk-41567619"
	],
	"./Rider/RefillCredit.vue": [
		"dbe3",
		"chunk-32ecbfc9"
	],
	"./Rider/RequestCash.vue": [
		"cb1f",
		"chunk-b8db8c44"
	],
	"./Rider/RequestCashLog.vue": [
		"25fa",
		"chunk-2d0b2f34"
	],
	"./Rider/RequestCredit.vue": [
		"0c7e",
		"chunk-2925b5f4"
	],
	"./Rider/RiderDashboard.vue": [
		"a70f",
		"chunk-9ddadf84"
	],
	"./Rider/RiderDeleted.vue": [
		"1b1f",
		"chunk-61d2bda2"
	],
	"./Rider/RiderDetail.vue": [
		"530d",
		"chunk-4817525e"
	],
	"./Rider/RiderEdit.vue": [
		"2a7c",
		"chunk-2d0bceb1"
	],
	"./Rider/RiderInHouse.vue": [
		"8c06",
		"chunk-61d5efad"
	],
	"./Rider/RiderPending.vue": [
		"513d",
		"chunk-2d0c7723"
	],
	"./Rider/Transaction.vue": [
		"a7a8",
		"chunk-7c185c13"
	],
	"./Rider/Wallet.vue": [
		"ad22",
		"chunk-2d213699"
	],
	"./Rider/WithdrawCash.vue": [
		"432a",
		"chunk-30817902"
	],
	"./Rider/WithdrawCommission.vue": [
		"0652",
		"chunk-691949e6"
	],
	"./RiderTracker.vue": [
		"d387",
		"chunk-82c9d358"
	],
	"./RoleInformation.vue": [
		"ed7d",
		"chunk-2d2308e2"
	],
	"./RoleManage.vue": [
		"32ba",
		"chunk-2d0b97d4"
	],
	"./SelectDashboard.vue": [
		"0552",
		"chunk-33922e74"
	],
	"./SelectService.vue": [
		"49c4",
		"chunk-d0cfa756"
	],
	"./ServiceManage/index.vue": [
		"c3b7",
		"chunk-390136ce",
		"chunk-ac04ce36"
	],
	"./SetApp/OutOfServiceArea.vue": [
		"5941",
		"chunk-4677747a"
	],
	"./SetApp/PaymentMethod.vue": [
		"bf9a",
		"chunk-1c50a834"
	],
	"./SetApp/SetAppPopup/index.vue": [
		"f946",
		"chunk-390136ce",
		"chunk-31a7a601"
	],
	"./SetApp/SetAppStore/index.vue": [
		"072c",
		"chunk-f5d52824",
		"chunk-3f9697dd"
	],
	"./SetApp/SetAppStoreType/index.vue": [
		"59f2",
		"chunk-7357fed7"
	],
	"./SetApp/SetAppSubDistrict/index.vue": [
		"d5f8",
		"chunk-2d21e999"
	],
	"./SetApp/SetAppZone/index.vue": [
		"6d9f",
		"chunk-60207da4"
	],
	"./SetApp/SetPromotionBanner/index.vue": [
		"fcdb",
		"chunk-390136ce",
		"chunk-2d212b99",
		"chunk-15993b2e"
	],
	"./SetAppMaintenance.vue": [
		"154a",
		"chunk-390136ce",
		"chunk-63f96bc6"
	],
	"./SetAppNotification.vue": [
		"d6ac",
		"chunk-216b23f9",
		"chunk-195e18b1",
		"chunk-b0b557f4"
	],
	"./TierBenefitsManage/index.vue": [
		"1ae1",
		"chunk-355a9bce"
	],
	"./TransferTokenQueue.vue": [
		"823d",
		"chunk-1d0dceeb"
	],
	"./UserManage.vue": [
		"1ed4",
		"chunk-5f36a2db"
	],
	"./WeserveADS.vue": [
		"3f71",
		"chunk-390136ce",
		"chunk-69a8f1a6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1368";
module.exports = webpackAsyncContext;